import type { ILeadsSearchFiltersDto } from "app/pages/sales-intelligence/modules/leads-search-filters/types/leadsSearchFilters.dto";
import { createNamespacedAction } from "app/pages/sales-intelligence/store/utils";

const createLeadsSearchFiltersAction = createNamespacedAction("si/leads-search-filters");

export const setLeadsFilterValue = createLeadsSearchFiltersAction<Partial<ILeadsSearchFiltersDto>>("set-filter-value");

export const updateLeadsFilterValue =
    createLeadsSearchFiltersAction<Partial<ILeadsSearchFiltersDto>>("update-filter-value");

/** @deprecated Re-exports from advanced-search-filtering (panel state actions moved there) */
export {
    setSelectedFilterCategory,
    setIsFiltersCategoriesPanelExpanded,
    setIsFiltersPanelExpanded,
    setFilterMode,
} from "app/pages/sales-intelligence/modules/advanced-search-filtering/store/action-creators";
